module.exports = __webpack_public_path__ + "img/services-6.3abfd069.jpg";